module.exports = __webpack_public_path__ + "3344566e139ec1d1efdcc115aa512c8c.png";